/**
 * Sänkykonfiguraattori → "Varaa aika" -popup (Easy Appointment Booking / Servicify).
 *
 * Kopioi asiakkaan konfiguraattorivalinnat varausmodaalin vapaan tekstin kenttään
 * ("Tausta- ja lisätiedot halutessasi"), jotta myymälä näkee etukäteen mitä sänkyä
 * asiakas on katsonut. Teksti menee appin omana line item -propertynä varaukselle.
 *
 * Ei koske appin omaan logiikkaan: kenttä täytetään React-yhteensopivasti ja vain
 * jos asiakas ei ole itse kirjoittanut siihen mitään.
 */
(() => {
  // Mihin kenttään kirjoitetaan. Jos appin kysymyksen nimi muuttuu Shopify-adminissa,
  // päivitä tämä hakusana (verrataan kentän labeliin ja name-attribuuttiin).
  const FIELD_PATTERN = /lis[äa]tied/i;

  // Appin varausnappi. data-href on appin oma, data-servicify-modal-bound tulee kun appi on sitonut napin.
  const BOOKING_TRIGGER = '[data-href*="servicify-calendar"], [data-servicify-modal-bound]';

  // Modaali avataan monivaiheisena, joten tarkkaillaan DOMia hetki – mutta ei loputtomiin.
  const MAX_WATCH_MS = 10 * 60 * 1000;

  let observer = null;
  let frame = 0;
  let startedAt = 0;
  let modalSeen = false;

  /** Tuotteen nimi + konfiguraattorin valinnat. Hinta jätetään pois: varaus ei ole tilaus. */
  function summaryText() {
    const root = document.querySelector('sanky-configurator');
    if (!root) return '';

    const summary = root.querySelector('[data-sanky-prop="Kokoonpano"]')?.value?.trim();
    if (!summary) return '';

    let title = '';
    try {
      title = JSON.parse(root.querySelector('[data-sanky-config]').textContent)?.product?.title || '';
    } catch (_) {
      // Ilman otsikkoa pärjätään, valinnat ovat se tärkeä osa
    }

    const lines = [];
    if (title) lines.push(`Malli: ${title}`);
    // Yhteenveto on muodossa "Patja: X · Kangas: Y · Yht. 0 €" – riveiksi luettavuuden vuoksi
    summary
      .split(' · ')
      .filter((part) => !/^Yht\./i.test(part.trim()))
      .forEach((part) => lines.push(part));

    return lines.join('\n');
  }

  /** Etsii oikean tekstikentän avoinna olevasta modaalista. */
  function findField() {
    const fields = document.querySelectorAll('textarea[data-servicify="custom-field-input"], textarea[data-servicify-input="textField"]');

    for (const field of fields) {
      const label = field.id ? document.querySelector(`label[for="${CSS.escape(field.id)}"]`)?.textContent : '';
      const haystack = [label, field.getAttribute('data-servicify-label'), field.getAttribute('name')].join(' ');
      if (FIELD_PATTERN.test(haystack)) return field;
    }

    return null;
  }

  /**
   * Kenttä on Reactin hallinnassa, joten pelkkä .value ei riitä: arvo pitää asettaa
   * natiivilla setterillä ja lähettää input-tapahtuma, jotta React päivittää tilansa.
   */
  function setReactValue(field, value) {
    const setter = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value')?.set;
    if (setter) setter.call(field, value);
    else field.value = value;

    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /** @returns {boolean} true kun kenttä on käsitelty eikä tarkkailua enää tarvita */
  function tryFill() {
    const field = findField();
    if (!field) return false;
    if (field.dataset.sankyPrefilled) return true;

    // Asiakkaan oma teksti voittaa aina
    if (field.value.trim() !== '') {
      field.dataset.sankyPrefilled = '1';
      return true;
    }

    const text = summaryText();
    if (!text) return true;

    setReactValue(field, text);
    field.dataset.sankyPrefilled = '1';
    return true;
  }

  function stopWatching() {
    observer?.disconnect();
    observer = null;
    modalSeen = false;
  }

  function check() {
    frame = 0;

    const modalOpen = !!document.querySelector('.ReactModal__Content');
    if (modalOpen) modalSeen = true;

    if (tryFill()) {
      stopWatching();
      return;
    }
    // Modaali ehti sulkeutua tai käyttäjä jätti sen auki pitkäksi aikaa
    if ((modalSeen && !modalOpen) || Date.now() - startedAt > MAX_WATCH_MS) stopWatching();
  }

  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(check);
  }

  function startWatching() {
    startedAt = Date.now();
    if (observer) return;
    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    schedule();
  }

  // Appi rakentaa napin uudelleen, joten kuunnellaan delegoidusti dokumentista
  document.addEventListener(
    'click',
    (event) => {
      if (event.target instanceof Element && event.target.closest(BOOKING_TRIGGER)) startWatching();
    },
    true
  );
})();
